<app-cabecalho></app-cabecalho>

<app-produto-menu></app-produto-menu>

<app-footer></app-footer>